import { gql } from 'graphql-request'

export const GENNERATE_COUPONS = gql`
  mutation GenerateCoupons($generateCouponsInput: GenerateCouponsInput!) {
    generateCoupons(generateCouponsInput: $generateCouponsInput) {
      message
    }
  }
`
